var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isMobile)?_c('HomeMobile'):_c('HomePc')
}
var staticRenderFns = []

export { render, staticRenderFns }